// extracted by mini-css-extract-plugin
export default {"stepStatus":"step-status_stepStatus__bLZec"};